// src/i18n/locales/en/homePage.ts
export const enHomePageTranslations = {
	homepage: {
		features: 'Features',
		pricing: 'Pricing',
		templates: 'Templates',
		readyToStart: 'Ready to Transform Your Restaurant Menu?',
		startDescription: 'Join thousands of restaurants that are elevating their digital presence with our customizable menu platform.',
		stats: {
			title: 'Trusted by Restaurants Worldwide',
			subtitle: 'Join thousands of restaurants that have already transformed their digital presence',
			restaurants: 'Happy Restaurants',
			menusViewed: 'Menus Viewed Monthly',
			salesIncrease: 'Average Sales Increase',
			countries: 'Countries Served'
		},
		cta: {
			title: 'Ready to Transform Your Restaurant?',
			subtitle: 'Join thousands of restaurants that have boosted their sales with beautiful digital menus.',
			rating: 'customer rating',
			trustedBy: 'Trusted by',
			restaurants: 'restaurants',
			watchDemo: 'Watch Demo',
			features: {
				setup: '5-minute setup',
				support: '24/7 support',
				guarantee: '30-day guarantee'
			}
		}
	},
	hero: {
		titleHighlight: 'Digital Menus',
		titleRest: 'that Delight Your Customers',
		subtitle: 'Create stunning, customizable online menus that are easy to update and accessible from any device.',
		browseTemplates: 'Browse Templates',
		trustBadge: 'Trusted by 10,000+ restaurants',
		restaurants: 'restaurants trust us',
		watchDemo: 'Watch Demo',
		sales: 'Sales Growth',
		rating: 'Rating'
	},
	features: {
		sectionTitle: 'Everything You Need to Succeed',
		sectionSubtitle: 'Powerful features designed specifically for restaurants to create stunning digital menus that drive sales.',
		badge: 'Why Choose Us',
		bottomCTA: 'Join 10,000+ restaurants already growing with Dine.ai',
		customization: {
			title: 'Easy Customization',
			description: "Personalize your menu with your brand colors, fonts, and layout to match your restaurant's identity perfectly.",
		},
		responsive: {
			title: 'Fully Responsive',
			description: 'Your menu looks perfect on any device - from smartphones and tablets to desktop computers.',
		},
		multilingual: {
			title: 'Multilingual Support',
			description: 'Serve international customers by offering your menu in multiple languages with RTL support.',
		},
		analytics: {
			title: 'Advanced Analytics',
			description: 'Gain insights into your most viewed and popular items to optimize your offerings and increase sales.',
		},
		security: {
			title: 'Secure & Reliable',
			description: 'Your data is protected with enterprise-grade security, regular backups, and 99.9% uptime.',
		},
		performance: {
			title: 'Lightning Fast',
			description: 'Optimized for speed with instant loading times that keep your customers engaged.',
		},
	},
	testimonials: {
		sectionTitle: 'What Our Customers Say',
		sectionSubtitle: 'Don\'t just take our word for it - hear from restaurant owners who have transformed their business with Dine.ai.',
		badge: 'Customer Stories',
		person1: {
			name: 'Sarah Johnson',
			role: 'Owner, The Rustic Table',
			content: "Dine.ai transformed our outdated paper menus into a beautiful digital experience. Our customers love it, and we've seen a 20% increase in our average order value!",
		},
		person2: {
			name: 'Michael Chen',
			role: 'Manager, Fusion Bistro',
			content: 'The ability to quickly update our menu items and prices has been a game-changer. We also love the analytics that help us understand our most popular dishes.',
		},
		person3: {
			name: 'Lucia Garcia',
			role: 'Chef, La Mariposa',
			content: 'As someone who changes the menu seasonally, Dine.ai makes it incredibly easy to showcase our new dishes with beautiful images and descriptions.',
		},
	},
	benefits: {
		sectionTitle: 'Transform Your Restaurant Experience',
		sectionSubtitle: 'Discover how digital menus can revolutionize your business operations and enhance customer satisfaction.',
		business: {
			title: 'Boost Your Business',
			description: 'Increase revenue with upselling opportunities, reduce printing costs, and improve operational efficiency through real-time menu updates.',
		},
		customer: {
			title: 'Enhanced Customer Experience',
			description: 'Provide customers with interactive, visually appealing menus that include detailed descriptions, allergen information, and high-quality images.',
		},
		efficiency: {
			title: 'Save Time & Resources',
			description: 'Eliminate the need for reprinting menus. Update prices, descriptions, and availability instantly across all locations.',
		},
		environment: {
			title: 'Eco-Friendly Solution',
			description: 'Reduce paper waste and contribute to environmental sustainability while providing a modern dining experience.',
		},
		accessibility: {
			title: 'Universal Accessibility',
			description: 'Ensure your menu is accessible to all customers with features like multiple languages, large text options, and voice compatibility.',
		},
		global: {
			title: 'Reach Global Audiences',
			description: 'Attract international visitors with multilingual menus and culturally appropriate presentation options.',
		},
		whyChoose: {
			title: 'Why Choose Dine.ai?',
			description: 'Dine.ai combines cutting-edge technology with user-friendly design to deliver a comprehensive digital menu solution that grows with your business.',
		},
		features: {
			easySetup: 'Quick Setup',
			easySetupDesc: 'Get your digital menu live in minutes with our intuitive setup process.',
			noMaintenance: 'Zero Maintenance',
			noMaintenanceDesc: 'We handle all technical updates and maintenance, so you can focus on your business.',
			instantUpdates: 'Real-time Updates',
			instantUpdatesDesc: 'Changes appear instantly across all devices and locations.',
			support: '24/7 Support',
			supportDesc: 'Our dedicated support team is always here to help you succeed.',
		},
	},
	footer: {
		description: 'Dine.ai helps restaurants create beautiful, customizable digital menus that delight customers and boost sales.',
		product: 'Product',
		features: 'Features',
		pricing: 'Pricing',
		templates: 'Templates',
		customization: 'Customization',
		company: 'Company',
		about: 'About Us',
		blog: 'Blog',
		careers: 'Careers',
		contact: 'Contact',
		support: 'Support',
		help: 'Help Center',
		docs: 'Documentation',
		status: 'System Status',
		privacy: 'Privacy Policy',
		rights: 'All rights reserved.',
	},
}